import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Utility provided by shadcn-vue for composing Tailwind class names.
 *
 * Combines two libraries:
 *  - clsx  — merges conditional class arrays/objects into a single string
 *  - tailwind-merge — resolves Tailwind class conflicts (e.g. `p-2 p-4` → `p-4`)
 *    so that the last relevant class always wins, preventing specificity bugs.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
